var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_4603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 15.8333H13.3333V12.5H11.1C10.15 14.5167 8.1 15.8333 5.83333 15.8333C2.61667 15.8333 0 13.2167 0 9.99999C0 6.78332 2.61667 4.16666 5.83333 4.16666C8.1 4.16666 10.1417 5.48332 11.1 7.49999H20V12.5H18.3333V15.8333ZM15 14.1667H16.6667V10.8333H18.3333V9.16666H9.95L9.75833 8.60832C9.175 6.94999 7.59167 5.83332 5.83333 5.83332C3.53333 5.83332 1.66667 7.69999 1.66667 9.99999C1.66667 12.3 3.53333 14.1667 5.83333 14.1667C7.59167 14.1667 9.175 13.05 9.75833 11.3917L9.95 10.8333H15V14.1667ZM5.83333 12.5C4.45833 12.5 3.33333 11.375 3.33333 9.99999C3.33333 8.62499 4.45833 7.49999 5.83333 7.49999C7.20833 7.49999 8.33333 8.62499 8.33333 9.99999C8.33333 11.375 7.20833 12.5 5.83333 12.5ZM5.83333 9.16666C5.375 9.16666 5 9.54166 5 9.99999C5 10.4583 5.375 10.8333 5.83333 10.8333C6.29167 10.8333 6.66667 10.4583 6.66667 9.99999C6.66667 9.54166 6.29167 9.16666 5.83333 9.16666Z",
    fill: "#3C3C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_4603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.a687c10343e7dd99df300b7b01e4f1d3.svg";
export { ForwardRef as ReactComponent };